export default {
  product: {
    title: 'Product',
    selfCustodyWallet: 'Mobile Wallet',
    selfCustodyWalletDesc: 'Crypto&DeFi Mobile Wallet on Blockchain.',
    hardwareWallet: 'Hardware Wallet',
    hardwareWalletDesc: 'Get Your KeyPal, to Guard Your Assets.',
    extensionWallet: 'Extension Wallet',
    extensionWalletDesc: 'A Better Wallet on Your Computer.',
    transit: 'Transit',
    transitDesc: 'Multi-chain DEX Aggregator and NFT Marketplace Platform.',
    fiveDegrees: '5Degrees',
    fiveDegreesDesc: 'Social Network Protocol in Web3.0.',
    stakeVault: 'ETH Staking Vault',
    stakeVaultDesc:
      'Support Both Self-Custodial Staking and Small Amount Staking',
  },
  project: {
    subDApp: 'Submit DApp',
    subToken: 'Submit Token',
    subNFT: 'Submit NFT',
    subChain: 'Submit Chain',
  },
  assets: {
    title: 'Assets',
  },
  collaborations: {
    title: 'Collaborations',
  },
  community: {
    title: 'Community',
    developers: 'Developers',
    recruiting: 'TP Man',
  },
  helpCenter: {
    title: 'Help',
  },
  features: {
    title: 'Features',
    buyCrypto: 'Buy Crypto',
    mobileWallet: 'Mobile Wallet',
    hardwareWallet: 'Hardware Wallet',
    extensionWallet: 'Extension Wallet',
    desktop: 'Desktop Wallet',
    fiveDegrees: '5Degrees',
    approvalDetector: 'Approval Detector',
    tokenSecurity: 'Token Security',
    keyGenerator: 'Key Generator',
    BATCH_SENDER: 'BatchSender',
  },
  information: {
    title: 'Information',
    blockchainGuide: 'Blockchain Guide',
    tronWallet: 'TRON Guide',
    iostWallet: 'IOST Guide',
    tpMan: 'TP Man',
  },
  developers: {
    title: 'Developers',
    github: 'Github (TP-Lab)',
    devCenter: 'Dev Center',
    subToken: 'Submit Token',
    subDApp: 'Submit DApp',
    subNFT: 'Submit NFT',
  },
  company: {
    title: 'Company',
    about: 'About',
    careers: 'Careers',
    pressKit: 'Press Kit',
    swagShop: 'Swag Shop',
  },
  support: {
    title: 'Support',
    helpCenter: 'Help Center',
    contactUs: 'Contact Us',
  },
  legal: {
    title: 'Legal',
    privacyPolicy: 'Privacy Policy',
    terms: 'Terms of Use',
  },
  main: {
    title: 'Version Verification',
    language: '中文',
    intro:
      'Version verification is performed by matching the MD5 or SHA256 hash values between versions. Please make sure to download TokenPocket wallet through official channels to avoid being deceived. For instructions on how to obtain the MD5 or SHA256 hash values of a version, please ',
    tutorial: 'refer to the tutorial >',
    system: 'OS',
    android: 'Android',
    ios: 'iOS',
    version: 'Version',
    allVersion: 'All',
    appChannel: 'App Channel',
    developer: 'Developer',
    allChannel: 'All',
    md5: 'MD5',
    sha256: 'SHA256',
    log: 'Version Log',
    check: 'Details',
    versionLog: 'Version Log',
    confirm: 'Confirm',
    aboutIOS: 'About iOS Version',
    IOSDesc:
      'For iOS versions, we only offer our App on App Store. Only apps downloaded through the App Store can be properly installed. Therefore, when using Apple devices, please make sure to authenticate the App Store as the sole download channel.',
    IOSDesc_2:
      'The developer of the version downloaded from the App Store before October 8, 2022 is TOKENPOCKET FOUNDATION LTD, which is an early version developed by TokenPocket. It is a legitimate wallet that can be used normally, but the update service will be temporarily suspended.',
    aboutAndroid: 'About Android Version',
    androidDesc: 'The current channels for downloading TokenPocket on Android include the official website, Google Play Store, Samsung Galaxy Store, Huawei AppGallery, OPPO App Store, and Vivo App Store. Please note that some app stores may not provide the APK installation package during the download process, making it impossible to perform MD5 or SHA256 checksum verification. Therefore, when downloading, please make sure to verify the developer information carefully, as listed below!',
    IOSAppName: 'Application Name:',
    TPWallet: 'TP Wallet',
    AppIcon: 'Application Icon:',
    AppDeveloper: 'Developer:',
    downloadLink: 'Download Url:',
    copied: 'Copied!',
    versionVerification: 'Version Verification',
  },
  follow: {
    title: 'Follow Us',
    desc1: "TokenPocket Staffs won't send you private messages!",
    desc2:
      "Caution! You're entering TokenPocket community, there might be someone impersonating us to send you private messages! Please be aware that, anyone who sends private messages might be a scammer! We will never contact you first!",
    desc3: 'Understood, enter',
  },
};
